var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("hasError", { attrs: { e: _vm.error } }),
      _vm._v(" "),
      _vm.isDisabled
        ? [
            _c("textInput", {
              attrs: {
                label: _vm.label ? _vm.label : "",
                type: "TEXT",
                iniDisabled: true,
                value: _vm.theValue
                  ? `${_vm.theValue.id} - ${_vm.theValue.name}`
                  : null,
              },
            }),
          ]
        : [
            _c(
              "textInput",
              {
                attrs: {
                  type: "CUSTOM",
                  label: _vm.label ? _vm.label : "",
                  v: _vm.v,
                },
              },
              [
                _vm.description
                  ? _c("template", { slot: "help" }, [
                      _vm._v(_vm._s(_vm.description)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "template",
                  { slot: "custom" },
                  [
                    _c(
                      "b-dropdown",
                      {
                        staticClass: "dropdown-listed",
                        attrs: { "aria-role": "menu", "mobile-modal": false },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "button is-cancel is-outlined",
                            staticStyle: {
                              "text-transform": "none",
                              "font-weight": "normal",
                            },
                            attrs: { slot: "trigger" },
                            slot: "trigger",
                          },
                          [
                            _vm.isLoading
                              ? [
                                  _c("loader", { attrs: { text: " " } }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "mr5-xs" }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.theValue
                              ? _c("span", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "tag is-primary mr5-xs",
                                      staticStyle: { "margin-left": "-5px" },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.theValue.id) + " "
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.theValue.name) +
                                      "\n                        "
                                  ),
                                ])
                              : [
                                  _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("choose")) +
                                        "\n                            "
                                    ),
                                  ]),
                                ],
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "icon" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: ["fas", "angle-down"] },
                                }),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown-item",
                          { attrs: { "aria-role": "menu-item", custom: "" } },
                          [
                            _c("textInput", {
                              ref: "search",
                              attrs: { type: "SEARCH" },
                              on: {
                                input: () => {
                                  _vm.fetchData()
                                },
                              },
                              model: {
                                value: _vm.searchTerm,
                                callback: function ($$v) {
                                  _vm.searchTerm = $$v
                                },
                                expression: "searchTerm",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isLoading
                          ? _c(
                              "b-dropdown-item",
                              {
                                staticClass: "is-info",
                                attrs: { "aria-role": "menu-item" },
                              },
                              [
                                _c("loader", {
                                  attrs: { text: _vm.$t("searching") },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.data && _vm.data.length == 0 && !_vm.isLoading
                          ? _c(
                              "b-dropdown-item",
                              {
                                staticClass: "is-info",
                                attrs: { "aria-role": "menu-item" },
                              },
                              [_vm._v(_vm._s(_vm.$t("nothingFound")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.data, function (item, index) {
                          return _c(
                            "b-dropdown-item",
                            {
                              key: index,
                              attrs: {
                                "aria-role": "menu-item",
                                "has-link": "",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.doUpdate(item.id)
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "tag" }, [
                                    _vm._v(" " + _vm._s(item.id) + " "),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(item.name) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        !_vm.showDefaults
                          ? [
                              _c("pagination", {
                                attrs: {
                                  count: _vm.count,
                                  hidePerPage: true,
                                  iniPerPage: 10,
                                },
                                model: {
                                  value: _vm.pagination,
                                  callback: function ($$v) {
                                    _vm.pagination = $$v
                                  },
                                  expression: "pagination",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.value
                          ? [
                              _c("hr", {
                                staticClass: "dropdown-divider",
                                attrs: { "aria-role": "menuitem" },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "aria-role": "menu-item" },
                                  on: { click: _vm.doUpdate },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "icon" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "times"] },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(" " + _vm._s(_vm.$t("clear")) + " "),
                                  ]),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }